
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
// import PanelGroup from './components/PanelGroup.vue'
import {
  getDashboard,
  getBalanceLineChart,
  getLineChart,
  getPieChart,
  getMerchantBalanceRank,
  getMerchantDepositRank,
  getMerchantWithdrawRank,
  getMerchantBalance
} from '@/api/dashboard'
import exTotal from './components/exTotal.vue'
import depositTotal from './components/depositTotal.vue'
import orderTotal from './components/orderTotal.vue'
import lineChart from './components/lineCharts.vue'
import pieChart from './components/pieCharts.vue'
import rank from './components/rank.vue'
import merchantBalance from './components/merchantBalance.vue'
import { AppModule } from '@/store/modules/app'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import moment from 'moment'
import { delObjEmptyKey } from '@/utils'
import { getName, getLogo, getType } from '@/utils/cookies'
import { getAntManageList } from '@/api/antManage/antManage'
import ChartPie from './components/pic.vue'

const initDate = getCurrentDate()
@Component({
  name: 'Dashboard',
  components: {
    exTotal,
    depositTotal,
    orderTotal,
    lineChart,
    pieChart,
    rank,
    merchantBalance,
    ChartPie
    // PanelGroup,
  }
})
export default class extends mixins(productOptionMixin, currencyOptionMixin) {
  queryForm: any = {
    merchant_no: null,
    start_time: initDate[0],
    end_time: initDate[1],
    unit: null,
    group_by: 'product_code',
    id: null
  }
  private totalData: any = {
    abnormal_operation: {},
    deposit: {},
    withdraw: {}
  }
  private balanceRank: any[] = []
  private depositRank: any[] = []
  private withdrawRank: any[] = []
  private amountChartData: any[] = []
  private volumeChartData: any[] = []
  private rateChartData: any[] = []
  private amountProductPieData: any[] = []
  private amountAccountPieData: any[] = []
  private volumeProductPieData: any[] = []
  private volumeAccountPieData: any[] = []
  private balanceChartData: any[] = []
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions
  private chartLoading: boolean = false
  private totalLoading: boolean = false
  private isLoop: boolean = false
  // 时间粒度
  get granularityList() {
    let list: any[] = []
    if (this.date) {
      const diff = moment(this.date[1]).diff(moment(this.date[0]), 'days')
      if (diff <= 1) {
        list = ['15m', '30m', '60m']
      } else if (diff > 1 && diff <= 2) {
        list = ['4h']
      } else if (diff > 2 && diff <= 3) {
        list = ['6h']
      } else if (diff > 3) {
        list = ['1d']
      }
      this.queryForm.unit = list[0]
    }
    return list
  }

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private async select() {
    await this.getDashboard()
    await this.getLineChart()
    // this.getBalanceLineChart()
    await this.getPieChart()
    await this.getMerchantBalanceRank()
    await this.getMerchantDepositRank()
    await this.getMerchantWithdrawRank()
    await this.onlaodtMerchantBalance()
  }
  private async currencyChange() {
    // this.queryForm.group_by = 'product_code'
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.select()
  }

  private reset() {
    this.queryForm = {
      currency: this.queryForm.currency,
      merchant_no: null,
      start_time: null,
      end_time: null,
      unit: null,
      group_by: 'product_code',
      product_code: null,
      product_account_no: null,
      ant_username: null
    }
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.init(false)
    })
  }

  // 获取统计数据
  private async getDashboard() {
    try {
      this.totalLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getDashboard(data).then((res: any) => {
        const rate: any = (
          (res.deposit.success_count / res.deposit.total_count) *
          100
        ).toFixed(2)
        res.deposit.success_rate = (rate === NaN ? '0' : rate) + '%'
        this.totalData = res
        this.totalLoading = false
      })
    } catch (e) {
      this.totalLoading = false
    }
  }

  // 获取余额折线图
  private async getBalanceLineChart() {
    try {
      this.balanceChartData = []
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getBalanceLineChart(data).then((res: any) => {
        this.balanceChartData = res.map((item: any) => {
          return {
            balance: item.balance,
            time: item.time
          }
        })
        this.chartLoading = false
      })
    } catch (e) {
      this.chartLoading = false
    }
  }

  // 获取折线图数据
  private async getLineChart() {
    try {
      this.amountChartData = []
      this.volumeChartData = []
      this.rateChartData = []
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getLineChart(data).then((res: any) => {
        res.forEach((item: any) => {
          this.amountChartData.push({
            succeed_amount: item.succeed_amount,
            total_amount: item.total_amount,
            time: item.time
          })
          this.volumeChartData.push({
            succeed_volume: item.succeed_volume,
            total_volume: item.total_volume,
            time: item.time
          })
          this.rateChartData.push({ rate: item.rate, time: item.time })
        })
        this.chartLoading = false
      })
    } catch (e) {
      this.chartLoading = false
    }
  }

  // 获取饼图数据
  private pieData: any[] = []
  private async getPieChart() {
    const data: any = {
      ...this.queryForm
    }
    await getPieChart(data).then((res: any) => {
      this.pieData = res
    })
  }

  private groupTypeChange(value: string) {
    this.queryForm.group_by = value
    this.$nextTick(() => {
      this.getPieChart()
    })
  }

  // 获取商户可用余额排行榜
  private async getMerchantBalanceRank() {
    try {
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantBalanceRank(data).then((res: any) => {
        this.balanceRank = res
      })
    } catch (e) {}
  }

  // 获取商户入金排行榜
  private async getMerchantDepositRank() {
    try {
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantDepositRank(data).then((res: any) => {
        this.depositRank = res
      })
    } catch (e) {}
  }

  // 获取商户出金排行榜
  private async getMerchantWithdrawRank() {
    try {
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantWithdrawRank(data).then((res: any) => {
        this.withdrawRank = res
      })
    } catch (e) {}
  }

  // 获取商户余额列表
  private merchantBalanceData: any = {}
  private async onlaodtMerchantBalance() {
    try {
      const data: any = {
        // ...this.queryForm
        currency: this.queryForm.currency,
        merchant_no: this.queryForm.merchant_no
      }
      await getMerchantBalance(data).then((res: any) => {
        this.merchantBalanceData = res
      })
    } catch (e) {}
  }

  private remoteMethod(query) {
    this.hadleGetFilesListApi(query)
  }

  private listLoading: boolean = false
  private master: any[] = []
  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi(name) {
    try {
      this.listLoading = true
      const data: any = {
        name: name,
        page_size: 100,
        page: 1
      }
      delObjEmptyKey(data)
      await getAntManageList(data).then((res: any) => {
        this.master = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private sysType: any = ''
  private async init(isLoop: boolean) {
    this.queryForm.group_by = 'product_code'
    this.isLoop = isLoop
    await this.getDashboard()
    await this.getLineChart()
    // this.getBalanceLineChart()
    await this.getPieChart()
    await this.getMerchantBalanceRank()
    await this.getMerchantDepositRank()
    await this.getMerchantWithdrawRank()
    await this.onlaodtMerchantBalance()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init(false)
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.dashboard`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
